<ng-container *ngIf="loading; else content">
  <div class="loading-container">
    <mat-spinner diameter="40"></mat-spinner>
  </div>
</ng-container>

<ng-template #content>
  <ng-container *ngIf="items.length > 0; else empty">
    <div class="media-grid">
      <ng-container *ngFor="let item of items">
        <app-image-card
          *ngIf="item.type === 'image'"
          [image]="item.data"
          [modelName]="item.modelName"
        ></app-image-card>
        <app-video-card
          *ngIf="item.type === 'video'"
          [video]="item.data"
          [modelName]="item.modelName"
        ></app-video-card>
      </ng-container>
    </div>
  </ng-container>

  <ng-template #empty>
    <div class="empty-state">
      <mat-icon>{{ emptyIcon }}</mat-icon>
      <p>{{ emptyMessage }}</p>
    </div>
  </ng-template>
</ng-template>
